import "core-js/modules/es.regexp.exec.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const SEARCH_MAPI_COMPLETED = 'frontend-shell:search-mapi-completed';
const SEARCH_MAPI_COMPLETED_WITH_ERROR = 'frontend-shell:search-mapi-completed-with-error';
export default ({
  AB,
  trigger,
  fetcher,
  getMapiLandingPage,
  metaURL,
  setSessionStorageKey
}) => {
  const searchMapiCompleted = data => {
    if (!data.errors && getMapiLandingPage() !== 'RESULT') {
      trigger(SEARCH_MAPI_COMPLETED, _objectSpread(_objectSpread({}, data), {}, {
        errors: null
      }));
      return {
        redirect: true
      };
    }
    if (data.errors) {
      handlerSearchMapiError();
    }
    setSessionStorageKey('repricingMAPI', undefined);
    return {
      redirect: false
    };
  };
  const handlerSearchMapiError = () => {
    trigger(SEARCH_MAPI_COMPLETED_WITH_ERROR);
  };
  const handlerCreateMapiShoppingCart = async ({
    search
  }) => {
    if (AB.isFecoCheckoutPassengers) {
      return {
        redirect: false
      };
    }
    if (AB.isPreCreateShoppingCartMeta || getMapiLandingPage() === 'RESULT') {
      return searchMapiCompleted(search);
    } else {
      return fetcher.post(metaURL).json().then(shoppingCartResponse => {
        return searchMapiCompleted(_objectSpread(_objectSpread({}, search), shoppingCartResponse));
      }).catch(() => {
        handlerSearchMapiError();
        return Promise.reject();
      });
    }
  };
  return {
    handlerCreateMapiShoppingCart,
    handlerSearchMapiError
  };
};